module.exports = __webpack_public_path__ + "img/flag_purple_20dp@2x.b435be4d.png";